export class Pais{
    //Pk
    paisId : number;
    //Atributos
    pais : string;
    codigo: string;
    idioma: string;
    coordenada: string;

    // US242: Metadatos de configuración dinámica por país
    nivelesTerritoriales: number;
    nombreNivel1: string;
    nombreNivel2: string;
    nombreNivel3: string;
    nombreIdFiscal: string;
    simboloMoneda: string;
    codigoMoneda: string;
    zonaHoraria: string;

    copiar(objeto : any){
        //Propios
        this.paisId = objeto.paisId;
        this.pais = objeto.pais; 
        this.codigo = objeto.codigo;       
        this.idioma = objeto.idioma;     
        this.coordenada = objeto.coordenada;
        // US242
        this.nivelesTerritoriales = objeto.nivelesTerritoriales;
        this.nombreNivel1 = objeto.nombreNivel1;
        this.nombreNivel2 = objeto.nombreNivel2;
        this.nombreNivel3 = objeto.nombreNivel3;
        this.nombreIdFiscal = objeto.nombreIdFiscal;
        this.simboloMoneda = objeto.simboloMoneda;
        this.codigoMoneda = objeto.codigoMoneda;
        this.zonaHoraria = objeto.zonaHoraria;
    }
}